/**
 * Расположение блоков отделов-исполнителей на вкладке «Исполнители» (карточка задачи).
 * Ключ — id из registers.departments; название отдела в UI можно менять без правок сетки.
 *
 * Коды в БД: PO, SNAB_UL, SMO_UL, PTO_UL, CZ, SMO_FL, PTO_FL
 */
export const EXECUTOR_DEPT_GRID: Array<Array<number | null>> = [
  [13, 16, 10, 6, 15],
  [null, null, 9, 4, null],
];
